const volumes = {
    carafe: { ml: 535, oz: 18.09 },
    'carafe-vertuo': { ml: 535, oz: 18.09 },
    alto: { ml: 335, oz: 11.33 },
    mug: { ml: 230, oz: 7.77 },
    gran_lungo: { ml: 150, oz: 5.07 },
    lungo: { ml: 110, oz: 3.7 },
    double_espresso: { ml: 80, oz: 2.7 },
    'double-espresso-vertuo': { ml: 80, oz: 2.7 },
    espresso: { ml: 40, oz: 1.35 },
    'espresso-vertuo': { ml: 40, oz: 1.35 },
    ristretto: { ml: 25, oz: 0.84 }
}

export const getCupSize = (size, isOz) => {
    const unit = isOz ? 'oz' : 'ml'
    const volume = volumes[size]

    if (!volume) {
        return ''
    }

    return `${volume[unit]} ${unit}`
}
